var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75065 16.4994H6.41732C6.69232 16.4994 6.87565 16.4077 7.05898 16.2244L17.1423 6.14102C17.509 5.77435 17.509 5.22435 17.1423 4.85768L13.4757 1.19102C13.109 0.824349 12.559 0.824349 12.1923 1.19102L2.10898 11.2744C1.92565 11.4577 1.83398 11.641 1.83398 11.916V15.5827C1.83398 16.1327 2.20065 16.4994 2.75065 16.4994ZM3.66732 12.2824L12.834 3.11578L15.2173 5.49911L6.05065 14.6658H3.66732V12.2824ZM19.2507 21.0827C19.8007 21.0827 20.1673 20.716 20.1673 20.166C20.1673 19.616 19.8007 19.2494 19.2507 19.2494H2.75065C2.20065 19.2494 1.83398 19.616 1.83398 20.166C1.83398 20.716 2.20065 21.0827 2.75065 21.0827H19.2507Z",
    fill: "#2667B0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5868_24173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 20,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75065 16.4994H6.41732C6.69232 16.4994 6.87565 16.4077 7.05898 16.2244L17.1423 6.14102C17.509 5.77435 17.509 5.22435 17.1423 4.85768L13.4757 1.19102C13.109 0.824349 12.559 0.824349 12.1923 1.19102L2.10898 11.2744C1.92565 11.4577 1.83398 11.641 1.83398 11.916V15.5827C1.83398 16.1327 2.20065 16.4994 2.75065 16.4994ZM3.66732 12.2824L12.834 3.11578L15.2173 5.49911L6.05065 14.6658H3.66732V12.2824ZM19.2507 21.0827C19.8007 21.0827 20.1673 20.716 20.1673 20.166C20.1673 19.616 19.8007 19.2494 19.2507 19.2494H2.75065C2.20065 19.2494 1.83398 19.616 1.83398 20.166C1.83398 20.716 2.20065 21.0827 2.75065 21.0827H19.2507Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5868_24173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#2667B0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconBlue);
export default __webpack_public_path__ + "static/media/edit_icon_blue.76451b579e1416010d8c0b423d19db86.svg";
export { ForwardRef as ReactComponent };